export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return
  if (to.path.startsWith('/api') || to.path.startsWith('/_nuxt')) return
  // Check if we're on email verification pages (any language)
  if (to.path.includes('/email/verify')) return
  // Check if we're on any language variant of profile edit page
  const profileEditPaths = ['/panel/profile/edit', '/ky/panel/profile/edit']
  if (profileEditPaths.some((path) => to.path === path || to.path.endsWith(path))) {
    return
  }
  const { user, isLoggedIn, isProfileIncomplete } = useUser()
  if (!isLoggedIn.value || !user.value) return
  if (user.value.accepted_document_id === null) return
  if (isProfileIncomplete.value) {
    // Get current locale from cookie
    const currentLocale = useCookie('user_locale').value || 'ru'
    const targetPath =
      currentLocale === 'ru' ? '/panel/profile/edit' : `/${currentLocale}/panel/profile/edit`
    return navigateTo(targetPath)
  }
})
